// utils/localStorage.ts
// export const saveState = (state: any) => {
//     try {
//       const serializedState = JSON.stringify(state);
//       localStorage.setItem("tourState", serializedState);
//     } catch (err) {
//       console.error("Error saving state to Local Storage:", err);
//     }
//   };
  
//   export const loadState = () => {
//     try {
//       const serializedState = localStorage.getItem("tourState");
//       if (serializedState === null) {
//         return undefined; 
//       }
//       return JSON.parse(serializedState);
//     } catch (err) {
//       console.error("Error loading state from Local Storage:", err);
//       return undefined;
//     }
//   };


export const saveState = (state: any) => {
    try {
      const serializedState = JSON.stringify(state);
      localStorage.setItem("tourState", serializedState);
    } catch (err) {
      console.error("Error saving state to Local Storage:", err);
    }
  };
  
  export const loadState = () => {
    try {
      const serializedState = localStorage.getItem("tourState");
      if (serializedState === null) {
        return undefined; 
      }
      return JSON.parse(serializedState);
    } catch (err) {
      console.error("Error loading state from Local Storage:", err);
      return undefined;
    }
  };
  
  export const clearState = () => {
    try {
      localStorage.removeItem("tourState");
    } catch (err) {
      console.error("Error clearing state from Local Storage:", err);
    }
  };
  
  